const BaseLayout = ({ children, pageClass }) => {
	return (
		<div className={`page layout-raw ${pageClass ? 'page-' + pageClass : ''}`}>{children}</div>
	);
};

export default BaseLayout;
